module.exports = __webpack_public_path__ + "static/img/detail_etc.798a4bff.svg";